import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CookieBannerContainerStyles } from './CookieBanner.styles';
import CookieBannerFooter from './CookieBannerFooter';
import CookieBannerHeader from './CookieBannerHeader';
import CookieBannerConsentSettings from './CookieBannerConsentSettings';

const CookieBanner = ({
    customBannerText: bannerText,
    cookieLinks,
    showSplashPrivacyPolicy,
    showSplashCookieList,
    showCompanyPrivacyPolicy,
    showCompanyCookiePolicy,
    showConsentSettings,
    showDeclineNonEssentialButton,
    onAcceptAll,
    onDeclineNonEssential,
    onConfirmSelection,
    cookieConsent,
}) => {
    const [consentSettings, setConsentSettings] = useState(
        cookieConsent ?? {
            performance: false,
            functionality: false,
            marketing: false,
        },
    );
    const [isConsentSettingsOpen, setIsConsentSettingsOpen] = useState(false);
    const styles = CookieBannerContainerStyles;

    const updateConsentSetting = (type, value) => {
        setConsentSettings((prevSettings) => ({
            ...prevSettings,
            [type]: value,
        }));
    };

    return (
        <div style={styles.container}>
            <CookieBannerHeader
                bannerText={bannerText}
                cookieLinks={cookieLinks}
                showSplashPrivacyPolicy={showSplashPrivacyPolicy}
                showSplashCookieList={showSplashCookieList}
                showCompanyPrivacyPolicy={showCompanyPrivacyPolicy}
                showCompanyCookiePolicy={showCompanyCookiePolicy}
            />
            {showConsentSettings && (
                <CookieBannerConsentSettings
                    isConsentSettingsOpen={isConsentSettingsOpen}
                    onClickOpenConsentSettings={() => setIsConsentSettingsOpen(!isConsentSettingsOpen)}
                    bannerText={bannerText}
                    consentSettings={consentSettings}
                    updateConsentSetting={updateConsentSetting}
                    onConfirmSelection={() => onConfirmSelection(consentSettings)}
                />
            )}
            <CookieBannerFooter
                bannerText={bannerText}
                isConsentSettingsOpen={isConsentSettingsOpen}
                showDeclineNonEssentialButton={showDeclineNonEssentialButton}
                onDeclineNonEssential={onDeclineNonEssential}
                onAcceptAll={onAcceptAll}
            />
        </div>
    );
};

CookieBanner.propTypes = {
    customBannerText: PropTypes.object,
    cookieLinks: PropTypes.object,
    showSplashPrivacyPolicy: PropTypes.bool,
    showSplashCookieList: PropTypes.bool,
    showCompanyPrivacyPolicy: PropTypes.bool,
    showCompanyCookiePolicy: PropTypes.bool,
    showConsentSettings: PropTypes.bool,
    showDeclineNonEssentialButton: PropTypes.bool,
    onAcceptAll: PropTypes.func,
    onDeclineNonEssential: PropTypes.func,
    onConfirmSelection: PropTypes.func,
    cookieConsent: PropTypes.oneOfType([
        PropTypes.shape({
            performance: PropTypes.bool,
            functionality: PropTypes.bool,
            marketing: PropTypes.bool,
        }),
        PropTypes.oneOf([null]),
    ]),
};

CookieBanner.defaultProps = {
    customBannerText: {},
    cookieLinks: {},
    showSplashPrivacyPolicy: true,
    showSplashCookieList: true,
    showCompanyPrivacyPolicy: false,
    showCompanyCookiePolicy: false,
    showConsentSettings: false,
    showDeclineNonEssentialButton: false,
    cookieConsent: null,
    onAcceptAll: () => {},
    onDeclineNonEssential: () => {},
    onConfirmSelection: () => {},
};

export default CookieBanner;
